module.exports = __webpack_public_path__ + "img/btn_color.5e0ae934.svg";